import { render, staticRenderFns } from "./AddMetaTagsModal.vue?vue&type=template&id=0f56640d&"
import script from "./AddMetaTagsModal.vue?vue&type=script&lang=js&"
export * from "./AddMetaTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports